// CONSTANTS
import { values } from 'constants/value'

// MUIS
import MuiGlobalStyles from '@mui/material/GlobalStyles'
import { alpha } from '@mui/material/styles'

const GlobalStyles = () => {
  // const zoomValue = 0.85

  return (
    <MuiGlobalStyles
      styles={(theme) => ({
        // ALL ELEMENTS
        '*, *::before, *::after': {
          boxSizing: 'border-box',
          fontFamily: values.fontFamilyOpenSans,
          shapeRendering: 'geometricPrecision',
          textRendering: 'geometricPrecision',
          imageRendering: 'optimizeQuality',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
        },

        // SCROLLBAR
        '&::-webkit-scrollbar': {
          width: 5,
          height: 5,
          backgroundColor: alpha('#000000', 0.16),
        },
        '&::-webkit-scrollbar-thumb': {
          width: 5,
          height: 5,
          backgroundColor: alpha('#000000', 0.2),
        },
        //STYLES
        '.marginRightAuto': {
          marginRight: 'auto !important',
        },
        '.boldText': {
          fontWeight: 600,
        },
        '.noMargin':{
          margin: 0
        },
        // ZOOM
        '@media only screen and (max-height: 820px)': {
          'body': {
            // zoom: zoomValue,
          },
          '.zoom': {
            // zoom: zoomValue,
          },
          '.no-zoom': {
            // zoom: 1 / zoomValue,
          },
        },
        '.textCapitalize': {
          textTransform: 'lowercase',
          '&:first-letter': {
            textTransform: 'capitalize'
          }
        },
      })}
    />
  )
}

export default GlobalStyles